module.exports = __webpack_public_path__ + "static/media/local-police.939521b2.svg";